import lodash from 'lodash'
import React, { useEffect } from 'react'

import { Col, FormRow } from '../../../../1stlog-ui/src/components/Bootstrap'
import Field, { useField } from '../../../../1stlog-ui/src/components/Field'
import Input from '../../../../1stlog-ui/src/components/Input'
import { usePrevious } from '../../../../1stlog-ui/src/hooks'

const DriverInstructions = (props) => {
  const {} = props

  const shipmentServices = useField('shipmentServices', { ignorePrefix: true })

  const [driverInstructions, setDriverInstructions] = useField(
    'driverInstructions',
    {
      asState: true,
    },
  )

  const showDriverInstructions = lodash.some(shipmentServices, (service) => {
    return lodash.get(service, 'name') === 'DIS'
  })

  const previousDriverInstructions = usePrevious(driverInstructions)
  useEffect(() => {
    if (previousDriverInstructions && !showDriverInstructions) {
      setDriverInstructions(undefined)
    }
  }, [showDriverInstructions])

  if (!showDriverInstructions) {
    return null
  }

  return (
    <FormRow hidden>
      <Col>
        <Field
          name="driverInstructions"
          label={i18n.t('driver_instructions', 'Fahreranweisungen')}
        >
          <Input />
        </Field>
      </Col>
    </FormRow>
  )
}

export default DriverInstructions
